import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { NavLink, Link } from 'react-router-dom';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';

//import { GetAuthUsername } from "../AuthUsername";

//import Header from "./Header";
//import SubMenu from "./SubMenu";
//import Find from "./Find";

import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
/*import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';*/
import { faPenToSquare, faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { faQrcode, faPlus, faUserPen, faFloppyDisk, faUser, faStar, faShirt, faPallet, faMagnifyingGlass, faSpinner, faRoadBarrier, faTrashCan, faUsersLine, faReceipt } from '@fortawesome/free-solid-svg-icons';
/*import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';*/
//import { DataTableFunc } from "../DataTableFunc"
import DataTable from 'react-data-table-component';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import ProfileInfo from './ProfileInfo';
import ProfileEmail from './ProfileEmail';
import ProfilePassword from './ProfilePassword';
import StudentCards from './StudentCards';

import useApiFetch from '../../ApiFetch';
import EventCard from '../events/EventCard';
import DashboardCard from './DashboardCard';
import MyPass from '../events/MyPass';

const isEmail = (email) =>
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export function Events() {
    const apiFetch = useApiFetch();

    const navigate = useNavigate();

    const [profile, setProfile] = useState(null);

    const [profileInfo, setProfileInfo] = useState({ firstName: '', lastName: '' });
    const [profileEmail, setProfileEmail] = useState('');


    const [additionalProducts, setAdditionalProducts] = useState([]);

    const [modalCompetitorLookup, setModalCompetitorLookup] = useState(false);
    const [competitorDetail, setCompetitorDetail] = useState(null);
    const [modalCompetitorDetail, setModalCompetitorDetail] = useState(false);
    const [eventsToAdd, setEventsToAdd] = useState([]);

    const [registrationPricing, setRegistrationPricing] = useState([]);
    const [spectatorPricing, setSpectatorPricing] = useState([]);

    const [competitorItems, setCompetitorItems] = useState([]);
    const [spectatorItems, setSpectatorItems] = useState([]);
    const [additionalItems, setAdditionalItems] = useState([]);
    const [appliedPromoCode, setAppliedPromoCode] = useState(null);
    const [productGroupFilter, setProductGroupFilter] = useState(null);

    const [modalTransactionComplete, setModalTransactionComplete] = useState(false);
    const [transactionRegistration, setTransactionRegistration] = useState(null);

    const [cont, setCont] = useState(null);

    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);




    const toggleCompetitorLookup = (open) => setModalCompetitorLookup(open === undefined ? !modalCompetitorLookup : open);
    const toggleCompetitorDetail = (open) => {
        setModalCompetitorDetail(open === undefined ? !modalCompetitorDetail : open);
        //    setEventsToAdd([]);
    };
    const toggleModalTransactionComplete = (open) => setModalTransactionComplete(open === undefined ? !modalTransactionComplete : open);


    useEffect(() => {
        getData();
    }, [cont]);

    const getData = async () => {
        setLoading(true);
        await apiFetch.get('/api/profile/event/')
            .then(resp => {
                let data = resp.data;
                if (data && data.length > 0) {
                    data = data.sort(function (a, b) {
                        // Turn your strings into dates, and then subtract them
                        // to get a value that is either negative, positive, or zero.
                        return new Date(b.startDate) - new Date(a.startDate);
                    })
                }
                setEvents(resp.data);
                setLoading(false);
            });
    };
    const getEventDates = (event) => {
        if (event) {
            let returnText = null;
            if (event.endDate) {
                //if we have an end date, check to see if the start and end dates are the same, if they are, show just one date
                if (event.endDate === event.startDate) {
                    returnText = moment(event.startDate).format('MMMM D, YYYY');
                }
                else {
                    //if the month is the same, show Month Start-End, otherwise, show Month Start - Month End
                    if (moment(event.startDate).month() === moment(event.endDate).month()) {
                        returnText = moment(event.startDate).format('MMMM') + ' ' + moment(event.startDate).format('D') + '-' + moment(event.endDate).format('D');
                        if (moment(event.startDate).year() === moment(event.endDate).year()) {
                            returnText += ', ' + moment(event.startDate).year();
                        }
                    }
                    else {
                        if (moment(event.startDate).year() === moment(event.endDate).year()) {
                            returnText = moment(event.startDate).format('MMMM D') + '-' + moment(event.endDate).format('MMMM D') + ', ' + moment(event.startDate).year();
                        }
                        else {
                            returnText = moment(event.startDate).format('MMMM D, YYYY') + ' - ' + moment(event.endDate).format('MMMM D, YYYY');
                        }
                    }
                }
            }
            else {
                returnText = moment(event.startDate).format('MMMM D, YYYY');
            }
            return returnText;
        }

    };



    return (
        <>
            <div className="container-xl px-2 pb-4">
                <div className="row d-flex g-3">
                    <div className="col-12">
                        <h4 className="d-flex justify-content-between align-items-center mb-3">
                            <span className="">My Events</span>
                        </h4>
                        <h6 className="d-flex justify-content-between align-items-center mb-3">
                            <span className="text-secondary">See the your event registrations below</span>
                        </h6>

                        {loading ?
                            <>
                                <div className="my-5">
                                    <div className="p-5 text-center">
                                        <div className="container py-5 text-muted">
                                            <h1 className="display-1 text-body-muted"><FontAwesomeIcon icon={faSpinner} spin /></h1>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            null
                        }
                        {events && events.length > 0 && !loading
                            ?
                            <div className="container-xl px-2 pb-4">
                                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 px-3 py-5">
                                    {events.map(e =>
                                        <div key={e.id} className="col">
                                            <div className="card shadow-sm h-100">
                                                <img src={e.imageUrl ? e.imageUrl : './assets/images/hyetech_logo2_4color.png'} className="bd-placeholder-img card-img-top" style={{ objectFit: e.imageUrl ? '' : 'contain', maxHeight: e.imageUrl ? '' : '150px' }} alt="" />
                                                <div className="card-body">
                                                    <h5 className="card-title">{e.title}</h5>
                                                    <h6>{getEventDates(e)}</h6>
                                                    {/*<p className="card-text" dangerouslySetInnerHTML={{ __html: e.shortDescription }} />*/}
                                                    <Link to={'/events/' + e.code} className="btn btn-primary" type="button">
                                                        Event Details
                                                    </Link>
                                                    {moment(e.startDate).startOf('day').diff(moment().startOf('day'), 'days') > -2 &&
                                                        <MyPass event={e} eventCode={e.code} iconOnly className="ms-2" />
                                                    //    <Link to={'/events/' + e.code + '/pass/'} className="btn btn-primary ms-2" type="button" title="My Pass" aria-label="My Pass">
                                                    //        <FontAwesomeIcon icon={faQrcode} />
                                                    //    </Link>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            :
                            <div class="p-5 text-center bg-body-tertiary rounded-3 m-0">
                                <h3 class="text-body-emphasis">You have no event registrations</h3>
                                <div class="row d-flex gap-2 my-3 justify-content-center">
                                    <div class="col-auto">
                                        <Link to="/events" className="d-inline-flex align-items-center btn btn-primary btn-sm-lg btn-lg px-4">
                                            View Events
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        }


                        {/*<div className="alert alert-danger" role="alert">*/}
                        {/*    An error has occurred and the profile was not created.<br />*/}
                        {/*    Please try again later.*/}
                        {/*</div>*/}
                        <div className="row g-3">
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

